import { Box, HStack, Text } from "@chakra-ui/react";
import { ITraderAvatarUser, TraderAvatar } from "src/components/common/trader-avatar";
import { WRITE_COMMENT_MODAL_OPENER_TEST_ID } from "./write-comment-modal-opener.test-ids";

export interface IWriteCommentProps {
    placeholder: string;
    trader: ITraderAvatarUser;
    onClick?: () => void;
}

export const WriteCommentModalOpener = ({ trader, placeholder, onClick }: IWriteCommentProps) => (
    <HStack
        width="100%"
        spacing={2}
        py={[2, 3]}
        px={[2, 5]}
        borderRadius="8px"
        boxShadow="sm"
        cursor="text"
        onClick={onClick}
        data-test-id={WRITE_COMMENT_MODAL_OPENER_TEST_ID}
    >
        <TraderAvatar size="md" trader={trader} />
        <Box
            width="100%"
            px={[0, 2]}
            py="12px"
            border={["0px", "1px"]}
            borderRadius="100px"
            borderColor="gray.100"
            color="gray.100"
            fontSize={["sm", "md"]}
        >
            <Text as="span" color="gray.500">
                {placeholder}
            </Text>
        </Box>
    </HStack>
);
